import Button from "../UI/Button";
import styles from "./FormAction.module.css";

const FormAction = () => {
  return (
    <div className={styles.form_actions}>
      <Button
        type="submit"
        className={
          styles["form_actions__contact-now"]
        }
      >
        Contact now
      </Button>
    </div>
  );
};

export default FormAction;
